var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3276 27.92H3.45397C1.54911 27.92 0 26.3754 0 24.4795V22.1469H2.36419C2.71094 22.1469 2.99014 21.8632 2.99014 21.5209C2.99014 21.1787 2.70644 20.895 2.36419 20.895H0V14.5905H2.36419C2.71094 14.5905 2.99014 14.3067 2.99014 13.9645C2.99014 13.6223 2.70644 13.3386 2.36419 13.3386H0V6.98H2.36419C2.71094 6.98 2.99014 6.6963 2.99014 6.35405C2.99014 6.01181 2.70644 5.7281 2.36419 5.7281H0V3.44947C0 1.54461 1.54911 0 3.45397 0H20.3276C22.2324 0 23.786 1.54461 23.786 3.44046V24.4795C23.786 26.3754 22.2324 27.92 20.3276 27.92ZM0.900645 23.0475V24.4795C0.900645 25.88 2.04446 27.0194 3.45397 27.0194H20.3276C21.7371 27.0194 22.8854 25.88 22.8854 24.4795V3.44046C22.8854 2.03996 21.7371 0.900645 20.3276 0.900645H3.45397C2.04446 0.900645 0.900645 2.03996 0.900645 3.44046V4.81845H2.36419C3.2063 4.81845 3.89079 5.50294 3.89079 6.34505C3.89079 7.18715 3.2063 7.87164 2.36419 7.87164H0.900645V12.4289H2.36419C3.2063 12.4289 3.89079 13.1134 3.89079 13.9555C3.89079 14.7976 3.2063 15.4821 2.36419 15.4821H0.900645V19.9853H2.36419C3.2063 19.9853 3.89079 20.6698 3.89079 21.5119C3.89079 22.354 3.2063 23.0385 2.36419 23.0385H0.900645V23.0475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3777 19.9688H9.38001C9.13233 19.9688 8.92969 19.7121 8.92969 19.4014C8.92969 19.0907 9.13233 18.834 9.38001 18.834H17.3777C17.6254 18.834 17.8281 19.0817 17.8281 19.4014C17.8281 19.7211 17.6254 19.9688 17.3777 19.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3777 23.2129H9.38001C9.13233 23.2129 8.92969 22.9563 8.92969 22.6455C8.92969 22.3348 9.13233 22.0781 9.38001 22.0781H17.3777C17.6254 22.0781 17.8281 22.3258 17.8281 22.6455C17.8281 22.9653 17.6254 23.2129 17.3777 23.2129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3427 11.2812H13.4103C15.824 11.2812 17.7829 13.2402 17.7829 15.6494V15.8926C17.7829 16.1402 17.5803 16.3429 17.3326 16.3429H9.42493C9.17275 16.3429 8.97461 16.1402 8.97461 15.8926V15.6494C8.97461 13.2402 10.9335 11.2812 13.3427 11.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.5469 7.5605C10.5469 6.03391 11.8168 4.79102 13.3794 4.79102C14.942 4.79102 16.2074 6.03391 16.2074 7.5605C16.2074 9.08709 14.9375 10.3255 13.3794 10.3255C11.8213 10.3255 10.5469 9.08259 10.5469 7.5605Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.a5b89d911cb599190f1c1abb8907cf97.svg";
export { ForwardRef as ReactComponent };